import {createSlice} from '@reduxjs/toolkit';

const initialState = {};

const microservicesSlice = createSlice({
  name: 'microservices',
  initialState,
  reducers: {
    setMicroservices: (state, action) => {
      let newState = {};
      for (let {id, ...microservice} of action.payload) {
        newState[id] = microservice;
      }
      return Object.assign(newState, state);
    },
    addMicroservice: (state, action) => {
      const {id, ...microservice} = action.payload;
      let newState = {};
      newState[id] = microservice;
      return Object.assign(newState, state);
    },
    updateMicroservice: (state, action) => {
      const {newId, id, ...newMicroservice} = action.payload;
      let newState = {};
      newState[newId] = {
        ...state[id],
        ...newMicroservice
      };
      for (let key in state) {
        if (key === id) continue;
        newState[key] = state[key];
      }
      return newState;
    },
    changeStatus: (state, action) => {
      const {id, status, fetcherIndex} = action.payload;

      if (fetcherIndex === undefined) {
        state[id].status = status;
        for (let fetcher of state[id].fetchers) {
          fetcher.status = status;
        }
      }
      else state[id].fetchers[fetcherIndex].status = status;
    },
    deleteMicroservice: (state, action) => {
      const {id} = action.payload;
      delete state[id];
    },
    clearMicroservices: () => initialState
  }
});

const {clearMicroservices, setMicroservices, addMicroservice, updateMicroservice, deleteMicroservice, changeStatus} = microservicesSlice.actions;

const microservicesReducer = microservicesSlice.reducer;

const selectMicroservices = (state) => state.microservices;

export {
  clearMicroservices,
  addMicroservice,
  setMicroservices,
  updateMicroservice,
  deleteMicroservice,
  changeStatus,
  microservicesReducer,
  selectMicroservices
};